import { FC } from 'react';

import ExternalButtonLink from '../ExternalButtonLink';
import locales from './locales';

interface RegulatedInstitutionDescriptionProps {
  moreInfoLinkHref?: string;
}

const RegulatedInstitutionDescription: FC<
  RegulatedInstitutionDescriptionProps
> = ({ moreInfoLinkHref }) => (
  <>
    <p>{locales.headerDescription}</p>
    {moreInfoLinkHref ? (
      <ExternalButtonLink href={moreInfoLinkHref}>
        {locales.linkLabelKnowMore}
      </ExternalButtonLink>
    ) : null}
  </>
);

export default RegulatedInstitutionDescription;
